import { useMutation, useQueryClient } from "@tanstack/react-query";
import { salveazaTargetareAmbiguitate } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useSalveazaTargetareAmbiguitate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: salveazaTargetareAmbiguitate,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.scoruri(),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.mapare() });
    },
  });
}
